import { ZegoExpressEngine } from 'zego-express-engine-webrtc';

const appID = 1707882354;
const server = 'wss://webliveroom1707882354-api.zegocloud.com/ws';

let engineInstance: ZegoExpressEngine | null = null;

export const createZegoEngineInstance = (): ZegoExpressEngine => {
  if (!engineInstance) {
    engineInstance = new ZegoExpressEngine(appID, server);
    engineInstance.setDebugVerbose(false);
  }
  return engineInstance;
};

export const zegoEngine = createZegoEngineInstance();
